module.exports = __webpack_public_path__ + "media/images/twitter_white-4af3e7d3bf5617df60d638ab9c29616b.png";